import React, { Component } from "react";
import { Router, Switch, Route } from "react-router-dom";
import { connect } from "react-redux";

import "./App.scss";
import Login from "./login";
import Logout from "./logout";
import Welcome from "./welcome";
import Training from "./training";
import Vc from "./vc";
import Reminders from "./reminders";
import Admin from "./admin";
import EditSetup from "./editVc";
import AddVc from "./addVc";
import DeleteVc from "./deleteVc";
import history from "../history";
import { reopenSession } from "../actions";
import userPool from "./auth/UserPool";
import ResetPassword from "./reset";
import ProtectedRoute from "./auth/ProtectedRoute";
import NotFound from "./FourOneFour";

class App extends Component {
  constructor(props) {
    super(props);
    const cognitoUser = userPool.getCurrentUser();
    if (cognitoUser) {
      cognitoUser.getSession((err, session) => {
        if (err) {
          console.log(err);
          history.push("/");
        } else {
          const jwt = session.getIdToken().jwtToken;
          this.props.reopenSession(jwt);
        }
      });
    } else if (window.location.pathname !== "/reset") {
      history.push("/");
    }
  }

  render() {
    return (
      <div className="App">
        <Router history={history}>
          <Switch>
            <Route path="/" exact component={Welcome}></Route>
            <Route path="/logout" exact component={Logout}></Route>
            <Route path="/reset" exact component={ResetPassword}></Route>
            <Route path="/welcome" exact component={Welcome}></Route>
            <ProtectedRoute
              path="/training"
              exact
              component={Training}
            ></ProtectedRoute>
            <ProtectedRoute path="/vc" exact component={Vc}></ProtectedRoute>
            <Route path="/reminders" exact component={Reminders}></Route>
            <ProtectedRoute
              path="/admin"
              exact
              component={Admin}
            ></ProtectedRoute>
            <ProtectedRoute
              path="/admin/edit/:vcid"
              exact
              component={EditSetup}
            ></ProtectedRoute>
            <ProtectedRoute
              path="/admin/add"
              exact
              component={AddVc}
            ></ProtectedRoute>
            <ProtectedRoute
              path="/admin/delete/:vcid"
              exact
              component={DeleteVc}
            ></ProtectedRoute>
            <Route component={NotFound} />
          </Switch>
        </Router>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return { auth: state.auth };
};

export default connect(mapStateToProps, { reopenSession })(App);
